<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click.prevent="submitForm">
                Enregistrer
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-form ref="testForm">
            <v-list three-line subheader>
              <v-subheader>Image</v-subheader>
              <v-list-item>
                <v-col cols="12" md="4" v-if="typeaction == 'update'">
                  <v-img
                    max-height="600"
                    max-width="600"
                    :src="redirect + '/public/' + template.image"
                  >
                  </v-img>
                </v-col>
                <v-col cols="12" md="4">
                  <picture-input
                    ref="pictureInput"
                    width="600"
                    height="600"
                    margin="16"
                    accept="image/jpeg,image/png"
                    size="10"
                    button-class="btn"
                    :custom-strings="{
                      upload: '<h1>Bummer!</h1>',
                      drag: 'Uploader le logo'
                    }"
                    id="imagearticle"
                    @change="onChange"
                  >
                  </picture-input>
                </v-col>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list three-line subheader>
              <v-subheader>Créer un article</v-subheader>

              <div class="container py-14 py-md-16">
                <div class="row">
                  <div class="col-md-12 mx-auto">
                    <div class="col-md-6">
                      <div class="form-floating mb-4">
                        <v-text-field
                          label="Titre"
                          placeholder=""
                          v-model="template.title"
                          :rules="[rules.required]"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-floating mb-4">
                        <v-text-field
                          label="Prix unitaire"
                          placeholder="12500"
                          :rules="[rules.required, rules.numeric]"
                          v-model="template.pricing"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-floating mb-4">
                        <v-text-field
                          label="mountant max de commande par jour "
                          placeholder="12"
                          v-model="template.max_amount"
                          :rules="[rules.required, rules.numeric]"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-floating mb-4">
                        <v-text-field
                          label="Nombre de pièce ou taiile"
                          placeholder="12 gateau / Taille:M"
                          v-model="template.pieces"
                          :rules="[rules.required]"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-floating mb-4">
                        <v-text-field
                          label="Code Article"
                          placeholder="PMb122"
                          v-model="template.code"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-floating mb-4">
                        <v-textarea v-model="template.description" color="teal">
                          <template v-slot:label>
                            <div>
                              Description de la l'article
                              <small>(recommandé)</small>
                            </div>
                          </template>
                        </v-textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-list>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import __ from "lodash-contrib";

export default {
  title: "editarticle",
  components: { PictureInput },
  props: {
    dialogedition: Boolean,
    redirect: String,
    shopid: String,
    indexarticle: Number,
    typeaction: String,
    toupdate: Object
  },
  watch: {
    yaya: function() {}
  },

  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      template: {
        id: null,
        title: "",
        pricing: "",
        max_amount: "",
        pieces: "",
        image: "",
        code: "",
        description: ""
      },
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        numeric: value => {
          console.log("isNumber(value) ==>", _.isNumber(value));
          if (!__.isNumeric(value)) {
            console.log(value + "  nest pas un number");
            return "Nous pouvez mettre que des chiffres.";
          }
        }
      }
    };
  },
  watch: {
    dialog: function(open) {
      if (!open) {
        this.$emit("closedialog", true);
      }
    },
    typeaction: function(type) {
      console.log("on est dans typeaction =>", this.typeaction);

      if (type == "update") {
        this.template = this.toupdate;
      }
      if (type == "creation") {
        this.template = {
          id: null,
          title: "",
          pricing: "",
          max_amount: "",
          pieces: "",
          image: "",
          code: "",
          description: ""
        };
      }
      console.log('template ==>',this.template);
    },
    indexarticle: function(indexArticle) {
      console.log("indexarticle == >", indexArticle);
      this.template.id = indexArticle + 1;
    },
    dialogedition: function(changement) {
      console.log("dialogedition has change ==>", changement);
      this.dialog = this.dialogedition;
      //on check en meme temps le type d'action demandée.
      /*
      if (changement) { if (this.typeaction == 'creation') this.template = { id: null, title: "", pricing: "", max_amount: "", pieces: "", image: "", code: "", description: "" } }
 */
    }
  },

  mounted() {},

  methods: {
    onChange(image) {
      if (image) {
        // this.template.image = image;
      }
    },
    submitForm() {
      if (this.$refs.testForm.validate()) {
        // Do something ...
        if (this.typeaction == "creation") {
          this.createArticle();
        } else if (this.typeaction == "update") {
          console.log("else if ==>", this.typeaction);
          this.editArticle();
        } else {
          this.$emit(
            "errormessage",
            "Vous devez remplir correctement le formulaire pour pouvoir créer une boutique"
          );
        }
      }
    },
    editArticle() {
      console.log("editArticle");
      let pathorder = this.redirect + `/update/shop/article/${this.shopid}`;

      let formData = new FormData();
      formData.append("idshop", this.shopid);
      formData.append("type", this.typeaction);
      _.forEach(this.template, function(value, key) {
        if (key !== "image") {
          formData.append(key, value);
        } else {
          // on charge l'image
          if (
            !_.isUndefined(document.getElementById("imagearticle").files[0])
          ) {
            formData.append(
              "image",
              document.getElementById("imagearticle").files[0]
            );
          } else {
            formData.append(key, value);
          }
        }
      });

      this.$http
        .post(pathorder, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          function(response) {
            console.log("response function(response) =>", response.data);
            let Oldthis = this;
            if (response.data.hasOwnProperty("acknowledged")) {
              if (
                response.data.acknowledged &&
                response.data.modifiedCount >= 1
              ) {
                Oldthis.template.image = response.data.image;
                console.log("acknwoledge true");
                Oldthis.$emit("successUpdate", Oldthis.template);
              }
            }
            this.dialog = false;
          },
          function(error) {
            console.log("error updating", error);
            this.$emit("errormessage", error.body.msg);
            this.dialog = false;
          }
        );
    },
    createArticle() {
      console.log(" <== updateShop ==> ", this.shopid);

      let pathorder = this.redirect + `/add/shop/article/${this.shopid}`;
      let Oldthis = this;
      this.template.id = this.indexarticle+1;

      let formData = new FormData();

      formData.append("idshop", this.shopid);
      formData.append("type", this.typeaction);

      _.forEach(this.template, function(value, key) {
        console.log("la clès ==> ", key);
        if (key !== "image") {
          formData.append(key, value);
        } else {
          // on charge l'image
          console.log("la clès si cest une image ==> ", key);
          formData.append(
            "image",
            document.getElementById("imagearticle").files[0]
          );
        }
      });

      this.$http
        .post(pathorder, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(
          function(response) {
            console.log("response update =>", response.data);
            let Oldthis = this;
            if (response.data.hasOwnProperty("acknowledged")) {
              if (
                response.data.acknowledged &&
                response.data.modifiedCount >= 1
              ) {
                Oldthis.template.image = response.data.image;
                console.log("acknwoledge true");
                Oldthis.$emit("successCreation", Oldthis.template);
              }
            }
          },
          function(error) {
            console.log("error updating", error);
            this.$emit("errormessage", error.body.msg);
          }
        );

      this.dialog = false;
    }
  }
};
</script>
<style>
.contentcoord {
  margin-bottom: 10px !important;
}
.subtitlecoord {
  list-style-type: disc;
  margin-left: 30px !important;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.padingtone {
  margin: 0px 5px 0px 5px;
}
.latlng {
  margin-top: 5px;
  margin-bottom: 15px;
  font-weight: normal !important;
}

.indication {
  word-wrap: break-word !important;
}

.livraison-content > .ya {
  margin-left: 12px;
}

.ya {
  margin-top: 8px;
  margin-bottom: 8px;
}

.card-tile > a {
  font-size: 12px;
  margin-left: 12px;
}

.btn-launch {
  border: 0;
  color: #fff !important;
  width: 100%;
  margin-bottom: 25px;
  padding-top: 17px !important;
  padding-bottom: 17px !important;
}
.yangozend {
  padding-bottom: 300px;
}
.v-messages__message {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pieces/editarticle.vue